export const componentMethods ={

  changeHtdqr(date){
        this.dataDetail.htdqr=date
      },
      changeJfrq(date){
        this.dataDetail.jfrq=date
      },
      changeCfrfysj(date){
        this.dataDetail['维保_出房人反馈时间']=date
      },
        changeTzrq(date){
        this.childModalObj['通知维保日期']=date
      },
        changeCcrq(date){
        this.dataDetail['维保_抽查日期']=date
      },
       changeTzwbrq(date){
        this.childModalObj.item_date=date
      },
      changeTzwbrqAdd(date){
        this.currentWeiBao.item_date=date
      },
      changeWcrq(date){
        this.dataDetail['维保_完成时间']=date
      },
      changeWanChengAdd(date){
        this.currentWanCheng.item_date=date
      },
      changeRepairgAdd(date){
        this.currentRepair.item_date=date
      },
      changeProjectAdd(date) {
         this.currentProject.item_date = date
      },
    changeModalDate(date) {
        this.childModalObj.item_date = date
    },
    changeSwitch(val){
        console.log(val)
    }
     


}